import { useState } from "react";
// import { Row, Col } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Outlet, Routes, Route, useParams } from "react-router-dom";
import ListProducts from "../components/List/List-Products";
import DashboardProducts from "../components/dashboard/Dashboard-Products";
import { MainSectionTitle } from "../../common";
import ListProductsWithOutSizeGuide from "../components/List/ListProductWithoutSizeGuide";
import ListProductsNotFound from "../components/List/List-ProdcutsNotFound";
import ListProductsWithoutActivity from "../components/List/List-ProductsWithoutActivity";
import ProductRegistration from "../components/crud/ProductRegistration";
import ProductEdit from "../components/crud/ProductEdit";
import { FormattedMessage } from "react-intl";

const MainProducts = (props: any) => {
  // const [showMenu, SetShowMenu] = useState(false);
  const [productsLength, setProductsLength] = useState(0);
  // const location = useLocation();
  // const navigate = useNavigate();
  const params = useParams();

  // console.log('Location', location);
  // console.log('Params', params);
  // console.log('Params["*"]', params['*']);
  // console.log('Navigate', navigate);

  const mainSectionContent = () => {
    const title =
      params["*"] === "" ? (
        <FormattedMessage id="ready-size-products" />
      ) : params["*"] === "list" ? (
        <FormattedMessage id="ready-size-products" />
      ) : params["*"] === "list-wsg" ? (
        <FormattedMessage id="mainProducts.title.listWsg" />
      ) : params["*"] === "list-nf" ? (
        <FormattedMessage id="mainProducts.title.listNf" />
      ) : params["*"] === "list-inactive" ? (
        <FormattedMessage id="mainProducts.title.listInactive" />
      ) : params["*"] === "create" ? (
        <FormattedMessage id="mainProducts.title.create" />
      ) : (
        <FormattedMessage id="mainProducts.title.edit" />
      );

    // const mainSectionContent = () => {
    //   const title =
    //     params["*"] === ""
    //       ? "Productos"
    //       : params["*"] === "list"
    //       ? "Productos"
    //       : params["*"] === "list-wsg"
    //       ? "Productos activos sin guía"
    //       : params["*"] === "list-nf"
    //       ? "Productos no reconocidos"
    //       : params["*"] === "list-inactive"
    //       ? "Productos sin actividad"
    //       : params["*"] === "create"
    //       ? "Alta de productos"
    //       : "Editar Productos";

    const subtitle =
      params["*"] === "list-wsg" ? (
        <FormattedMessage
          id="subtitle-list-wsg"
          defaultMessage="Revisa el siguiente listado y corrige los datos faltantes. ReadySize no puede hacer recomendaciones de talles en productos sin una guía asociada."
        />
      ) : params["*"] === "list-nf" ? (
        <FormattedMessage
          id="subtitle-list-nf"
          defaultMessage="Revisa el siguiente listado y corrige los datos faltantes. ReadySize no puede hacer recomendaciones de codificaciones no registradas."
        />
      ) : params["*"] === "list-inactive" ? (
        <FormattedMessage
          id="subtitle-list-inactive"
          defaultMessage="Los siguientes productos no fueron vistos en tu tienda online por más de 2 meses. ReadySize eliminará automáticamente los datos de productos sin uso luego de 3 meses."
        />
      ) : params["*"] === "create" ? (
        <FormattedMessage
          id="subtitle-create"
          defaultMessage="Los siguientes productos no fueron vistos en tu tienda online por más de 2 meses. ReadySize eliminará automáticamente los datos de productos sin uso luego de 3 meses."
        />
      ) : params["*"] === "edit" ? (
        <FormattedMessage
          id="subtitle-edit"
          defaultMessage="En Esta sección vas a poder editar tus productos. <b> Sugerencia:</b> conviene tener la guía de talles generada antes de editar los productos."
        />
      ) : (
        ""
      );

    // const subtitle =
    //   params["*"] === "list-wsg"
    //     ? "Revisa el siguiente listado y corrige los datos faltantes. ReadySize no puede hacer recomendaciones de talles en productos sin una guía asociada."
    //     : params["*"] === "list-nf"
    //     ? "Revisa el siguiente listado y corrige los datos faltantes. ReadySize no puede hacer recomendaciones de codificaciones no registradas."
    //     : /* Son los productos que tienes cargados en tu página web, pero no están dados de alta en Fitprenda.
    //     Suelen ser productos accesorios, por ejemplo: guantes, sombreros, cinturones, etc. que no son compatibles con Fitprenda.  */
    //     params["*"] === "list-inactive"
    //     ? "Los siguientes productos no fueron vistos en tu tienda online por más de 2 meses. ReadySize eliminará automáticamente los datos de productos sin uso luego de 3 meses."
    //     : params["*"] === "create"
    //     ? "Los siguientes productos no fueron vistos en tu tienda online por más de 2 meses. ReadySize eliminará automáticamente los datos de productos sin uso luego de 3 meses."
    //     : "En Esta sección vas a poder editar tus productos. <b> Sugerencia:</b> conviene tener la guías de talles generada antes de editar los productos"; /* En Esta sección vas a poder cargar y actualizar tus productos. <b> Sugerencia:</b> conviene tener la guías de talles generada antes de cargar los productos. */

    const variantBadge =
      params["*"] === "list-wsg"
        ? "danger"
        : params["*"] === "list-nf"
        ? "danger"
        : params["*"] === "list-inactive"
        ? "danger"
        : params["*"] === "list"
        ? "success"
        : "";

    return {
      title: title,
      subtitle: subtitle,
      badgeValue: productsLength,
      badgeVariant: variantBadge,
    };
  };

  return (
    <>
      <MainSectionTitle {...mainSectionContent()} />

      <div className="mt-4">
        <Outlet />
      </div>

      <Routes>
        <Route path={`/`} element={<DashboardProducts />} />
        <Route
          path={`/list`}
          element={
            <ListProducts
              onListProductChange={(value: number) => setProductsLength(value)}
            />
          }
        />
        <Route
          path={`/list-wsg`}
          element={
            <ListProductsWithOutSizeGuide
              onListProductChange={(value: number) => setProductsLength(value)}
            />
          }
        />
        <Route
          path={`/list-nf`}
          element={
            <ListProductsNotFound
              onListProductChange={(value: number) => setProductsLength(value)}
            />
          }
        />
        <Route
          path={`/list-inactive`}
          element={
            <ListProductsWithoutActivity
              onListProductChange={(value: number) => setProductsLength(value)}
            />
          }
        />
        <Route
          path={`/create`}
          element={<ProductRegistration canUpdload={false} />}
        />
        <Route
          path={`/uploads`}
          element={<ProductRegistration canUpdload={true} />}
        />
        <Route path={`/edit/:id`} element={<ProductEdit />} />
        {/* <Route path="/categories/*" element={<></>} />
                <Route path="/products/*" element={<MainProducts />} />
                <Route path="/sizes-guides/*" element={<></>} />
                <Route path="/tools/*" element={<></>} /> */}
      </Routes>
    </>
  );
};

export default MainProducts;
